import { render, staticRenderFns } from "./product-filter.vue?vue&type=template&id=02b040e9&"
import script from "./product-filter.vue?vue&type=script&lang=js&"
export * from "./product-filter.vue?vue&type=script&lang=js&"
import style0 from "./product-filter.vue?vue&type=style&index=0&id=02b040e9&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports